
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#1EC800","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M19.862 0H4.138A4.138 4.138 0 000 4.138v15.724A4.138 4.138 0 004.138 24h15.724A4.138 4.138 0 0024 19.862V4.138A4.138 4.138 0 0019.862 0m0 1.655a2.486 2.486 0 012.483 2.483v15.724a2.486 2.486 0 01-2.483 2.483H4.138a2.486 2.486 0 01-2.483-2.483V4.138a2.486 2.486 0 012.483-2.483h15.724"}}),_c('path',{attrs:{"d":"M13.907 6.503v5.546l-3.8-5.546H6v10.994h4.093v-5.546l3.8 5.546H18V6.503z"}})])])
          )
        }
      }
    